// extracted by mini-css-extract-plugin
module.exports = {"btn":"SelectIntervalAcceptanceType_btn__1zxic"};